import React, { useRef } from "react";
import {
  FileUploadContainer,
  FormField,
  FilePreviewContainer,
  ImagePreview,
  PreviewContainer,
  PreviewList,
  FileMetaData,
  InputLabel,
} from "./CustomFileUploadStyles";
import CheckRender from "../Common/CheckRender";
import { DeleteFilled } from "@ant-design/icons";
import Colors from "../../themes/Colors";
import pdfImage from "../../assets/img/pdf.png";
import txtImage from "../../assets/img/txt.png";
import fileImage from "../../assets/img/file.png";
import CustomButton from "../CustomButton/CustomButton";
import { getFileType } from "../../utils/FileUtils";
import Text from "../Common/Text";

const KILO_BYTES_PER_BYTE = 1000;

const DEFAULT_MAX_FILE_SIZE_IN_BYTES = 10000000;

const convertNestedObjectToArray = (nestedObj) =>
  Object.keys(nestedObj).map((key) => nestedObj[key]);

const convertBytesToKB = (bytes) => Math.round(bytes / KILO_BYTES_PER_BYTE);

const CustomFileUpload = ({
  label,
  buttonColor,
  files,
  setFiles,
  maxFileSizeInBytes = DEFAULT_MAX_FILE_SIZE_IN_BYTES,
  ...otherProps
}) => {
  const fileInputField = useRef(null);

  const handleUploadBtnClick = () => {
    fileInputField.current.click();
  };

  const addNewFiles = (newFiles) => {
    for (let file of newFiles) {
      if (file.size <= maxFileSizeInBytes) {
        if (!otherProps.multiple) {
          return { file };
        }
        files[file.name] = file;
      }
    }
    return { ...files };
  };

  const callUpdateFilesCb = (files) => {
    const filesAsArray = convertNestedObjectToArray(files);
    setFiles(filesAsArray);
  };

  const handleNewFileUpload = (e) => {
    const { files: newFiles } = e.target;
    if (newFiles.length) {
      let updatedFiles = addNewFiles(newFiles);
      callUpdateFilesCb(updatedFiles);
    }
  };

  const removeFile = (fileName) => {
    delete files[fileName];
    callUpdateFilesCb({ ...files });
  };

  const getFileImage = (fileType) => {
    switch (fileType) {
      case "pdf":
        return pdfImage;
      case "text":
        return txtImage;
      default:
        return fileImage;
    }
  };

  return (
    <>
      <FileUploadContainer>
        <InputLabel>{label}</InputLabel>
        <Text size="15px" margin={"1"}>
          {`Puedes arrastrar tus documentos aquí `}
        </Text>
        <CustomButton
          label={"Cargar Documentos"}
          onClick={handleUploadBtnClick}
          weight={"bold"}
          hoverColor={buttonColor}
          bgColor={Colors.white}
          textColor={buttonColor}
          border={`1px solid ${buttonColor}`}
        />
        <FormField
          type="file"
          ref={fileInputField}
          onChange={handleNewFileUpload}
          title=""
          value=""
          {...otherProps}
        />
      </FileUploadContainer>

      <FilePreviewContainer>
        <span>Vista previa</span>
        <PreviewList>
          {Object.keys(files).map((fileName, index) => {
            let file = files[fileName];
            let isImageFile = getFileType(file) === "image";
            return (
              <PreviewContainer key={fileName}>
                <div>
                  <CheckRender allowed={isImageFile}>
                    <ImagePreview
                      src={URL.createObjectURL(file)}
                      alt={`vista previa ${index}`}
                    />
                    <FileMetaData isImageFile={isImageFile}>
                      <span>{file.name}</span>
                      <aside>
                        <span>{convertBytesToKB(file.size)} kb</span>
                        <DeleteFilled
                          style={{ color: Colors.huMyHealth, fontSize: 25 }}
                          onClick={() => {
                            removeFile(fileName);
                          }}
                        />
                      </aside>
                    </FileMetaData>
                  </CheckRender>
                  <CheckRender allowed={!isImageFile}>
                    <img
                      src={getFileImage(getFileType(file))}
                      alt="Documento"
                      width="100"
                      height="100"
                    />
                    <FileMetaData isImageFile={true}>
                      <span>{file.name}</span>
                      <aside>
                        <span>{convertBytesToKB(file.size)} kb</span>
                        <DeleteFilled
                          style={{ color: Colors.huMyHealth, fontSize: 25 }}
                          onClick={() => {
                            removeFile(fileName);
                          }}
                        />
                      </aside>
                    </FileMetaData>
                  </CheckRender>
                </div>
              </PreviewContainer>
            );
          })}
        </PreviewList>
      </FilePreviewContainer>
    </>
  );
};

export default CustomFileUpload;